import { render } from "./SeStdTaxForm1065sm3.vue?vue&type=template&id=370046e2"
import script from "./SeStdTaxForm1065sm3.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm1065sm3.vue?vue&type=script&lang=js"

import "./SeStdTaxForm1065sm3.vue?vue&type=style&index=0&id=370046e2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__